import { useEffect, useState } from 'react';
import { GetCommandItems, CommandItem } from './types';

export const useGetCmdkItemsFromPromise = (
  callback: GetCommandItems,
  filterText: string,
): CommandItem[] => {
  const [state, setState] = useState<CommandItem[]>([]);

  useEffect(() => {
    callback(filterText).then(setState);
  }, [callback, filterText]);

  return state;
};
